import { render, staticRenderFns } from "./RelationChosenWidgetInput.vue?vue&type=template&id=3b43b35c&"
import script from "./RelationChosenWidgetInput.vue?vue&type=script&lang=js&"
export * from "./RelationChosenWidgetInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b43b35c')) {
      api.createRecord('3b43b35c', component.options)
    } else {
      api.reload('3b43b35c', component.options)
    }
    module.hot.accept("./RelationChosenWidgetInput.vue?vue&type=template&id=3b43b35c&", function () {
      api.rerender('3b43b35c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/inputs/RelationChosenWidgetInput.vue"
export default component.exports